import { createContext } from 'react';

const languageContext: {
  currentLanguage: Language;
  defaultLanguage: Language;
  translations: Queries.PageDAccueilQuery['wpPage']['translations'];
} = {
  currentLanguage: { code: 'EN', locale: 'en_GB', slug: 'en' },
  defaultLanguage: { code: 'EN', locale: 'en_GB', slug: 'en' },
  translations: undefined,
};

const LanguageContext = createContext(languageContext);

export default LanguageContext;
